module.exports = __webpack_public_path__ + "img/push-puller-4.1e4c0506.svg";